import { useState } from "react";
import { toast } from "react-toastify";
import { Button, FullScreenLoading, TextInput } from "src/Components";
import { IDeleteOMSOrder } from "src/Interfaces/deltaHedgeOrder";
import { deleteOMSOrders } from "src/Requests/deltaHedgeOrder";

const DeleteOMSOrderForm = () => {
  const [formValues, setFormValues] = useState({} as IDeleteOMSOrder);
  const [loading, setLoading] = useState(false);
  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setLoading(true);
    deleteOMSOrders(formValues).then((resp) => {
      if (resp.data) toast.success(resp.msg);
      else toast.error(resp.msg);
    });
  };

  return (
    <div className="grid grid-cols-2 gap-8">
      <div className="col-span-2 text-center font-bold">
        تنظیمات حذف سفارشات باز در OMS
      </div>
      {loading ? <FullScreenLoading /> : <></>}
      <TextInput
        label="حداقل زمان از ثبت سفارش(دقیقه)"
        name="minTimeInMinutes"
        onChange={changeHandler}
        value={formValues.minTimeInMinutes?.toString()}
        extraLabel
      />
      <div />
      <TextInput
        label="حداقل فاصله از سرخت(مقدار)"
        name="minDistanceFromTopPrice"
        onChange={changeHandler}
        value={formValues.minDistanceFromTopPrice?.toString()}
        extraLabel
      />
      <TextInput
        label="حداقل فاصله از سرخت(درصد)"
        name="minDistanceFromTopPricePercent"
        onChange={changeHandler}
        value={formValues.minDistanceFromTopPricePercent?.toString()}
        extraLabel
        kind="percent"
      />
      <div />
      <Button text="ثبت" onClick={onSubmit} variant="contained" />
    </div>
  );
};

export default DeleteOMSOrderForm;
